import React from 'react';
import {
	CancellationData,
	withCancellationContext,
} from '../../../context/CancellationProvider';
import {
	BREADCRUMB__INVOICE,
	BREADCRUMB__INVOICES,
} from '../../../data/labelsAndMessages';
import { useRouteMatch } from '../../../util/useRouteMatch';
import BreadcrumbsContainer, { Breadcrumb } from '../../BreadcrumbsContainer';
import LargeCenterSpinner from '../../LargeCenterSpinner';
import {
	IssuedCancellationRoutes,
	ISSUED_CANCELLATION_ROUTES,
} from '../Sidebar/IssuedCancellationSidebar';

interface Props {
	cancellationData: CancellationData;
}

const Breadcrumbs = (props: Props) => {
	const { policy, selectedCancellation } = props.cancellationData;
	const routeMatch = useRouteMatch(
		Object.keys(ISSUED_CANCELLATION_ROUTES).map(
			(key) =>
				ISSUED_CANCELLATION_ROUTES[key as keyof IssuedCancellationRoutes],
		),
	);
	const params = routeMatch?.params || {};
	const routeName = routeMatch?.pattern?.path || '';

	if (!policy || !selectedCancellation) {
		return <LargeCenterSpinner />;
	}

	const { policyholderLocator, locator } = policy;

	const breadcrumbs: Breadcrumb[] = [
		{ href: `/policyholder/${policyholderLocator}`, text: 'Policyholder' },
		{ href: `/policy/${locator}`, text: `Policy ${locator}` },
		{
			href: `/policy/${locator}/cancellations/${selectedCancellation.locator}`,
			text: `Cancellation ${selectedCancellation.locator}`,
		},
	];

	if (
		[
			ISSUED_CANCELLATION_ROUTES.INVOICE,
			ISSUED_CANCELLATION_ROUTES.INVOICES,
		].includes(routeName)
	) {
		breadcrumbs.push({
			href: ISSUED_CANCELLATION_ROUTES.INVOICES.replace(
				':policyId',
				policy.locator,
			).replace(':cancellationId', selectedCancellation.locator),
			text: BREADCRUMB__INVOICES(),
		});

		if (routeName === ISSUED_CANCELLATION_ROUTES.INVOICE) {
			breadcrumbs.push({
				href: ISSUED_CANCELLATION_ROUTES.INVOICE.replace(
					':policyId',
					policy.locator,
				)
					.replace(':cancellationId', selectedCancellation.locator)
					.replace(':invoiceId', params?.invoiceId),
				text: BREADCRUMB__INVOICE(params.invoiceId),
			});
		}
	}

	return <BreadcrumbsContainer breadcrumbs={breadcrumbs} />;
};

export default withCancellationContext<Props>(Breadcrumbs);
